/**
 * Minimal loading indicator with no component-library dependency - the extension
 * page belongs to the extension author, so nothing may touch its styles or
 * custom element registry just to show a spinner. Same asset as rc.loader().
 */
export const createLoader = (staticUrl = '/static/') => {
	const div = document.createElement('div');
	div.className = 'rpex-loader';
	div.style.cssText = 'width:100%;height:100%;min-height:80px;display:flex;align-items:center;justify-content:center;';
	const img = document.createElement('img');
	img.src = `${staticUrl}/assets/loader.webp`.replace(/([^:])\/\//g, '$1/');
	img.style.width = '40px';
	img.alt = '';
	div.appendChild(img);
	return div;
};
